import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import colors from 'styles/colors';

import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

interface Props {
  title: string;
  content: string | React.ReactElement;
  onBack?: boolean;
  onNext: () => void;
  onClose?: () => void;
  open: boolean;
}

function MappingsConfirmationDialog({ title, content, onBack, onNext, open, onClose }: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <div className={classes.root}>
        <Typography variant="h5" className={classes.title}>
          {title}
        </Typography>

        <Typography variant="body2" className={classes.content}>
          {content}
        </Typography>

        <div className={classes.buttonContainer}>
          {onBack && (
            <Button className={classes.backButton} onClick={onClose}>
              go back
            </Button>
          )}
          <Button onClick={onNext} variant="contained" color="secondary">
            continue
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 360,
    padding: 16,
  },
  title: {
    fontWeight: theme.typography.h6.fontWeight,
    marginBottom: theme.spacing(3),
  },
  content: {
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  backButton: {
    color: colors.black,
    marginRight: theme.spacing(2),
  },
}));

export default MappingsConfirmationDialog;
